import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ExtendedSignUp() {
    const [showModal, setShowModal] = useState(true);

    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm();

    const handleShowModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        reset();
    };

    const onSubmit = (data) => {
       // alert(JSON.stringify(data, null, 2));
        handleCloseModal();
    };

    const genderOptions = [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" },
    ];

    const referenceOptions = [
        { value: "1", label: "Facebook" },
        { value: "2", label: "Google" },
        { value: "3", label: "Magazine" },
        { value: "4", label: "Friends or Family" },
    ];



    return (
        <div>
            {/* <Button onClick={handleShowModal}>Open Form Modal</Button> */}

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                centered
                backdrop="static"
                keyboard={false}
            >
                {/* <Button className="email-alert-btn" onClick={handleCloseModal}>x</Button> */}
                <Modal.Body>
                    <h3 className="title">Fill your personal details to get exciting gift offers!</h3>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        {/* Gender */}
                        <Form.Group className="signup-formgroup">
                            <Controller
                                name="gender"
                                control={control}
                                rules={{ required: "Gender is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        options={genderOptions}
                                        placeholder="Gender"
                                        className="basic-select formfieldselect"
                                    />
                                )}
                            />
                            {errors.gender && <small className="text-danger">{errors.gender.message}</small>}
                        </Form.Group>

                        {/* Zipcode */}
                        <Form.Group className="signup-formgroup">
                            <Form.Control
                                type="text"
                                className="formfields"
                                placeholder="Zipcode"
                                {...register("zipcode", {
                                    required: "Zipcode is required",
                                    pattern: {
                                        value: /^[0-9]{5}$/,
                                        message: "Enter a valid 5-digit zipcode",
                                    },
                                })}
                            />
                            {errors.zipcode && <small className="text-danger">{errors.zipcode.message}</small>}
                        </Form.Group>

                        {/* Date of Birth */}
                        <Form.Group className="signup-formgroup formfielddob">
                            <Controller
                                name="dob"
                                control={control}
                                rules={{
                                    required: "Date of birth is required",
                                    validate: (value) => {
                                        const today = new Date();
                                        const birthDate = new Date(value);
                                        const age = today.getFullYear() - birthDate.getFullYear();
                                        const m = today.getMonth() - birthDate.getMonth();
                                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                                            return age - 1 >= 18 || "You must be at least 18 years old";
                                        }
                                        return age >= 18 || "You must be at least 18 years old";
                                    }
                                }}
                                render={({ field }) => (
                                    <DatePicker
                                        className="form-control formfields"
                                        placeholderText="Date of Birth"
                                        selected={field.value}
                                        onChange={field.onChange}
                                        dateFormat="dd/MM/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        maxDate={new Date()}
                                    />
                                )}
                            />
                            {errors.dob && <small className="text-danger">{errors.dob.message}</small>}
                        </Form.Group>

                        <Form.Group className="signup-formgroup">
                            <Controller
                                name="reference"
                                control={control}
                                rules={{ required: "Reference selection is required" }}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        options={referenceOptions}
                                        placeholder="Where did you hear about Torfacts?"
                                        className="basic-select formfieldselect"
                                    />
                                )}
                            />
                            {errors.reference && <small className="text-danger">{errors.reference.message}</small>}
                        </Form.Group>



                        <Button type="submit" className="signUp-submit mb-0" variant="success">Submit</Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default ExtendedSignUp;
